import React from "react";
import styles from "./Loading.module.css";
import AppSpinner from '../../partials/AppSpinner';

/* import { useHistory } from "react-router-dom"; */
/* import * as api from "../../utils/api"; */

/*
Stand by screen - visual

TODO: what imgs & data i want to download so it'll be on the
client phone

Check if the user is log in (by check the token)
YES - second check: the token is valid or status 401?
  YES - if Rakaz-league or player
    Rakaz - go to LeagueList
    Player - go to MyLeague
  NO - go to signin form
NO - go to signin/login form
*/

function Loading() {
  return (
    <div>
      <div className={styles.loadingHero}></div>
      <div className={styles.logo}></div>
      <div className={styles.spinner}>   <AppSpinner size={'large'} label={'טוען...'}/></div>

    </div>
  );
}

export default Loading;
